import { Page } from '@/core/architecture'

import { ConsoleBankEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleBankEdit Page
 * Implemented as a practical sample.
 */
export const ConsoleBankEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleBankEditTemplate state={state} {...actions} />
}
